function planValueCalc(plano, dependentes){
  let total = plano.valorMensalidadeTitular
  let count = 0
  if(!dependentes.length)
    return total;
  
  for(let dependente of dependentes){
    if(dependente.plano.valorMensalidadeDependente)
      total += dependente.plano.valorMensalidadeDependente;
    count++
    if(count>=dependentes.length)
      return total
  }
}

function vencimentoMensalidade(cliente) {
  let vencimento = new Date(cliente.ativacao?cliente.ativacao:cliente.cadastro)
  
  vencimento.setDate(vencimento.getDate())
  
  if(vencimento.getDate() < 6){
    vencimento.setDate(5)
    return vencimento
  }

  if(vencimento.getDate() < 11){
    vencimento.setDate(10)
    return vencimento
  }

  if(vencimento.getDate() < 16){
    vencimento.setDate(15)
    return vencimento
  }

  if(vencimento.getDate() < 21){
    vencimento.setDate(20)
    return vencimento
  }

  if(vencimento.getDate() < 26){
    vencimento.setDate(25)
    return vencimento
  }

  if(vencimento.getDate() < 31){
    vencimento.setDate(30)
    return vencimento
  }

  if(vencimento.getDate() === 31){
    vencimento.setDate(31)
    return vencimento
  }

}

function parcelaGenerate(data, i) {
  let newDate = new Date(data)
  let day = newDate.getDate()
  switch (day) {
    case day>=1&&day<=5:
      newDate.setDate(5)
      break;
    case day>=6&&day<=10:
      newDate.setDate(10)
      break;
    case day>=11&&day<=15:
      newDate.setDate(15)
      break;
    case day>=16&&day<=20:
      newDate.setDate(20)
      break;
    case day>=21&&day<=25:
      newDate.setDate(25)
      break;
    case day>=26&&day<=31:
      newDate.setDate(31)
      break;
    default:
      break;
  }
  
  newDate.setMonth(newDate.getMonth() + (i))
  
  return newDate
}

function carnetGenerate(parcelaInicial, cliente) {
  let carnet = []
  let totalParcelas = 12
  let count = 0

  for (let i = parcelaInicial; i <= totalParcelas; i++) {

    carnet.push({
      vencimento: parcelaGenerate(vencimentoMensalidade(cliente), i),
      valorParcela: + planValueCalc(cliente.plano, cliente.dependentes),
      mensalidade: `${i}/12`,
      cliente: cliente,
      plano: cliente.plano,
      pago: false,
    })
    count++
    if(count>= totalParcelas)
      return carnet
  }
}

export { carnetGenerate, planValueCalc, vencimentoMensalidade }